import { parseWidgetEnv } from './env.schema';

/**
 * Validated, typed environment for runtime use across the widget.
 * Import `env` rather than reaching into `import.meta.env` directly.
 */
export const env = parseWidgetEnv(import.meta.env as Record<string, unknown>);
